<!--
 * @Author: guoyu
 * @Date: 2020-09-09 16:53:02
 * @LastEditors: your name
 * @LastEditTime: 2021-05-08 15:05:09
 * @Description: 適用與展示過長的ui
-->
<template>
  <div class="swiper-collapse-container">
    <div class="swiper-index" v-if="showIndex && !isPc">
      {{currentIndex+1}}/{{options.length}}
    </div>
    <div class="left-arrow" v-if="!leftHide || ifLoop">
      <slot name="left">
        <i class="arrow-icon left-icon el-icon-arrow-left" @click="goLeft"></i>
      </slot>
    </div>
    <div class="right-arrow" v-if="!rightHide || ifLoop">
      <slot name="right">
        <i
          class="arrow-icon right-icon el-icon-arrow-right"
          @click="goRight"
        ></i>
      </slot>
    </div>
    <div class="swiper-collapse" ref="sc" :style="{'overflow-X': isTouchSwipe ? 'auto' : 'hidden'}">
      <div class="indicator-wrap" v-if="ifIndicator">
        <div
          class="indicator"
          v-for="(item, index) in options"
          :key="index"
          :class="currentIndex === index ? 'selected' : ''"
        ></div>
      </div>
      <div
        class="item-container"
        ref="itemContainer"
        :style="{
          marginLeft: '-' + marginLeft + 'px',
          transition: 'all ease ' + ts + 'ms',
         
        }"
      >
       <!-- transform: isIos ? 'translateZ(0px)' : '' -->
        <template v-for="(item, index) in options">
          <div class="sp-item" ref="itemRef" :key="index + 's'">
            <slot :item="item" :index="index" :active="val===index">
              {{ typeof item === 'object' ? item.label || item.value : item }}
            </slot>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Hammer from 'hammerjs';
export default {
  name: 'SwiperCollapse',
  model: {
    event: 'change',
    prop: 'val'
  },
  props: {
    ifIndicator: {
      type: Boolean,
      default: false
    },
    ifAutoPlay: {
      type: Boolean,
      default: false
    },
    ifLoop: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    // 滑動的數量
    sNum: {
      type: [String, Number],
      default: 1
    },
    options: {
      type: Array,
      default: () => []
    },
    val: {
      type: [String, Number],
      default: 0
    },
    // 動畫時長度
    ts: {
      type: [String, Number],
      default: 300
    },
    // 移動端滑動
    isTouchSwipe: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      marginLeft: 0,
      currentIndex: 0,
      canGo: true,
      timeOut: null,
      isIos: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    };
  },
  computed: {
    rightHide() {
      return this.sNum >= this.options.length - this.currentIndex;
    },
    leftHide() {
      return this.currentIndex <= 0 || this.sNum >= this.options.length;
    },
    isPc() {
      return window.innerWidth > 600
    }
  },
  created() {
    if (this.ifAutoPlay) {
      this.autoPlay();
    }
  },
  watch: {
    val(newVal) {
      if (newVal < 0) {
        this.currentIndex = 0
        this.$nextTick(()=>{
          this.setMargin();
        })
        return;
      }
      if (newVal >= this.options.length) {
        this.$emit('change', this.options.length - this.sNum + 1);
        return;
      }
      if (this.currentIndex === newVal) return;
      this.currentIndex = newVal;
      if (this.options.length <= this.sNum) return;
      this.$nextTick(()=>{
        this.setMargin();
      })
    }
  },
  methods: {
    // swiperEnd() {
    //   let scrollDom = this.$refs.sc
    //   if (scrollDom) {
    //     let scrollLeft = scrollDom.scrollLeft
    //     let targetIndex = parseInt(scrollLeft/375) + 1
    //     console.log(targetIndex)
    //     scrollDom.scrollTo({
    //       left: 375 * targetIndex,
    //       behavior: 'smooth'
    //     })
    //   }
    // },
    autoPlay() {
      this.timeOut = setTimeout(() => {
        this.goRight();
        this.autoPlay();
      }, 6000);
    },
    goLeft() {
      if (!this.canGo) return;
      this.resetScroll();
      this.canGo = false;
      if (this.currentIndex === 0 && this.ifLoop) {
        this.currentIndex = this.options.length - 1;
      } else {
        this.currentIndex -= this.sNum | 0;
        this.currentIndex = this.currentIndex < 0 ? 0 : this.currentIndex;
      }
      this.setMargin();
      this.$emit('change', this.currentIndex);
      this.clickFirbid();
    },
    resetScroll() {
      if (this.ifLoop) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.autoPlay();
        }, 4000);
      }
    },
    goRight() {
      if (!this.canGo) return;
      this.resetScroll();
      this.canGo = false;
      if (this.ifLoop && this.rightHide) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = this.rightHide
          ? this.currentIndex
          : this.currentIndex + (this.sNum | 0);
      }
      this.setMargin();
      this.$emit('change', this.currentIndex);
      this.clickFirbid();
    },
    setMargin() {
      this.canGo = false;
      if (this.isTouchSwipe) return
      if (!this.$refs.itemRef || !this.$refs.itemRef[this.currentIndex]) return;
      this.marginLeft += this.$refs.itemRef[this.currentIndex].offsetLeft;
      this.clickFirbid();
    },
    clickFirbid() {
      setTimeout(() => {
        this.canGo = true;
      }, (this.ts | 0) + 10);
    },
    touchSwipe(e) {
      this.marginLeft = this.startLeft - e.deltaX;
      this.marginLeft = this.marginLeft > 0 ? this.marginLeft : 0;
    }
  },
  mounted() {
    if (this.isPc) return

    this.swipeMc = new Hammer.Manager(this.$refs.sc);
    this.swipeEvent = new Hammer.Pan({ direction: 6 });
    this.swipeMc.add(this.swipeEvent);
    // this.swipeMc.on('pan', this.touchSwipe);
    let startX
    this.swipeMc.on('panstart', (e) => {
      startX = e.center.x
    });
    this.swipeMc.on('panend', (e) => {
      let endX = e.center.x
      let changeX = endX - startX
      if (changeX * changeX < 900) return
      if (changeX > 0) {
        this.goLeft()
      } else {
        this.goRight()
      }
    });
  },
  beforeDestroy() {
    if(this.swipeMc) {
      this.swipeMc.remove(this.swipeEvent);
    }
  }
};
</script>
<style lang="scss" scoped>
.swiper-collapse-container {
  position: relative;
}
.swiper-collapse {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  backface-visibility: hidden;
}
.indicator-wrap {
  width: 100%;
  height: 10px;
  position: absolute;
  bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.is-move {
  transform: translateY(0);
}
.indicator {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  opacity: 0.3;
  background: white;
  transition: all ease 0.3s;
  margin-right: 8px;
}
.selected {
  width: 30px;
  border-radius: 18px;
  opacity: 1;
}
.left-arrow,
.right-arrow {
  display: flex;
  position: absolute;
  top: 0;
  height: 100%;
  width: 1px;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.arrow-icon {
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
}
.left-arrow {
  left: 0;
}
.right-arrow {
  right: 0;
}
.left-icon {
  padding-right: 3px;
}
.right-icon {
  padding-left: 3px;
}
.item-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: all ease 0.3s;
}
.sp-item {
  flex-grow: 0;
  flex-shrink: 0;
}
@media screen and (max-width: 599px) {
  .swiper-index {
    width: 44px;
    height: 28px;
    line-height: 28px;
    background: rgba(0, 0, 0, 0.7);
    // border: 0.5px solid #999999;
    box-sizing: border-box;
    border-radius: 14px;
    position: absolute;
    top: 11px;
    z-index: 2;
    right: 9px;
    text-align: center;
    color: white;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    opacity: 0.8;
  }
}
</style>
